module.exports = __webpack_public_path__ + "static/media/towelvest.f5b91738.png";